import React from "react";
import ReactSelect from "react-select";
import history from "../../../history";
import apiClient from '../../../../utils/apiClient';

const validationColor = {
  control: (styles) => ({
    ...styles,
    borderLeftColor: "red",
    borderLeftWidth: "4px",
    borderRadius: "0",
  })
};

const customStyles = {
  control: (styles) => ({
    ...styles,
    fontSize: '13px',
  }),
  option: (provided) => ({
    ...provided,
    fontSize: '13px', // Adjust the font size as needed
  })
};


export default class CustomReactSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      isMulti: props.isMulti ?? false,
      optionsSelected: null,
      loadUrl: props.loadUrl,
      itemsSelected: props.itemsSelected ?? [],
      idColumnName: props.idColumnName,
      validation: true,
    };
  }
  
  componentDidMount() {
    if (this.state.loadUrl) {
      apiClient
        .get(this.state.loadUrl)
        .then((response) => {
          const data = response.data;
          if (data) {
            let allValues = data.map((item) => ({
              label: item.name,
              value: item[this.state.idColumnName],
              isEnabled: item.isEnabled,
              canEdit: true,
            }));
            let usedValues = allValues.filter(obj => obj.isEnabled);

            if (this.state.itemsSelected.length > 0) {
              this.state.itemsSelected.forEach((selectedItem) => {
                if (!usedValues.some((v) => v.value === selectedItem.id)) {
                  const missingOption = {
                    label: selectedItem.name,
                    value: selectedItem.id,
                    isEnabled: false,
                    canEdit: allValues.some((v) => v.value === selectedItem.id)
                  };
                  usedValues.push(missingOption);
                }
              });
            }

            const optionsSelected = usedValues.filter((option) =>
              this.state.itemsSelected.some((selectedItem) => selectedItem.id === option.value));
            optionsSelected.sort((a, b) => a.label.localeCompare(b.label));
            this.setState({
              options: usedValues,
              optionsSelected: optionsSelected,
            });
          }
        })
        .catch((error) => {
          if (error === "Unauthorized") {
            return;
          }
          console.error(error);
        });
    }
  }

  // Handle selection changes by identifying the added/removed option.
  // Prevent changes if the option does not have the right or is not enabled. 
  handleChange = (selected) => {
    selected = selected || [];
    const currentSelection = this.state.optionsSelected || [];

    // handle "Unselect all" button
    if (selected.length === 0) {
      const nonUnselectableOptions = currentSelection.filter(
        (opt) => !opt.canEdit
      );
      if (nonUnselectableOptions.length > 0) {
        this.setState({ optionsSelected: nonUnselectableOptions });
        return;
      }
    }

    // Handle individual select/unselect
    const changedOption =
      selected.find(
        (opt) => !currentSelection.some((cur) => cur.value === opt.value)
      ) ||
      currentSelection.find(
        (opt) => !selected.some((sel) => sel.value === opt.value)
      );

    if (changedOption) {
      // Logic for preventing addition of options without rights or not enabled
      if (
        (!currentSelection.some((opt) => opt.value === changedOption.value) &&
          (!changedOption.canEdit || !changedOption.isEnabled)) ||
        !changedOption.canEdit
      ) {
        return;
      }

      // Logic for allowing removal regardless of canEdit or isEnabled
      if (
        currentSelection.some((opt) => opt.value === changedOption.value) &&
        changedOption.canEdit
      ) {
        this.setState({
          optionsSelected: selected.filter(
            (opt) => opt.value !== changedOption.value
          ),
        });
        return;
      }
    }

    this.setState({ optionsSelected: selected });
  };


    componentDidUpdate(prevProps) {
    if (this.props.itemsSelected !== prevProps.itemsSelected) {
      const optionsSelected = this.state.options.filter((option) =>
        this.props.itemsSelected.some((selectedItem) => selectedItem.id === option.value)
      );
      this.setState({ optionsSelected: optionsSelected });
    }
  }

  getValidation = () => {
    if (
      this.state.optionsSelected == undefined ||
      this.state.optionsSelected == [] ||
      !this.state.optionsSelected.length
    ) {
      this.setState({ validation: false });
    } else {
      this.setState({ validation: true });
    }
  };

  render() {
    return (
      <>
        <ReactSelect
          options={this.state.options}
          isMulti={this.state.isMulti}
          styles={!this.state.validation ? validationColor : customStyles}
          closeMenuOnSelect={!this.state.isMulti}
          onMenuOpen={this.props.onMenuOpen}
          value={this.state.optionsSelected}
          className="custom-react-select"
          classNamePrefix={"react-select"}
          required
          defaultValue=""
          isOptionDisabled={(option) => !option.canEdit}      
          onChange={this.handleChange}
        />
        {!this.state.validation && <p className="p-required">Required</p>}
      </>
    );
  }
}